<template>
  <div>
    <div class="d-show-only-checkbox" @click.stop="isShowOnlySubjectsWithoutTeacher = !isShowOnlySubjectsWithoutTeacher">
      <label class="d-label">Vis kun fag uten underviser</label><input type="checkbox"
                                                                   v-model="isShowOnlySubjectsWithoutTeacher">
    </div>
    <ul class="doTable__items text-dark">
      <h2 class="text-explainer" v-if="calendarsWithProps.length === 0">Ingen klasser opprettet</h2>
      <li class="doTable__klass"
          v-for="calendar in calendarsWithProps"
          :key="calendar.id">
        <div class="doTable__klass__header">
          <div>{{ calendar.name }}</div>
          <div>
            <button class="do-bttn" @click="setIsCreate(calendar)">Opprett fag i klassen</button>
          </div>
        </div>
        <ul class="subjects">
          <h4 class="text-explainer" v-if="calendar.v_subjects.length < 1">Ingen fag opprettet</h4>
          <li class="subjects_subject"
              v-for="subject in calendar.v_subjects"
              :key="subject.id"
              v-if="isShowOnlySubjectsWithoutTeacher ? !subject.v_has_teacher : true"
              :style="{'background': subject.color}"
              :class="[{'subject--has-user': subject.v_has_teacher}, {'subject--has-room': subject.v_has_room}]"
              @click="setEditSubject(subject)"
              :content="subject.v_teacher_names"
              v-tippy="{
                    arrow: true,
                    onShow: () => subject.v_has_teacher
                  }">
            {{ subject.name }} ({{ subject.hours }})
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isShowOnlySubjectsWithoutTeacher: true
    }
  },
  computed: {
    calendars () {
      return this.$store.state.calendars
    },
    klassCalendars () {
      return this.$store.getters.klassCalendars
    },
    calendarsWithProps () {
      return this.klassCalendars.map(calendar => {
        const arrOfSubjects = this.tasksInCalendarHash[calendar.id] ? this.tasksInCalendarHash[calendar.id] : []
        const subjects = arrOfSubjects.map(id => this.subjectsInHash[id])
        const subjectsWithProps = subjects.map(subject => {
          return {
            ...subject,
            v_has_teacher: this.subjectHasTeachers(subject),
            v_has_room: this.subjectHasRoom(subject),
            v_teacher_names: this.getTeacherNames(subject)
          }
        })
        return {
          ...calendar,
          v_subjects: subjectsWithProps
        }
      })
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    tasks () {
      return this.$store.state.subjects.subjects
    },
    filteredTasks () {
      return this.tasks
    },
    sortedTasks () {
      return this.filteredTasks.sort((a, b) => a.name.localeCompare(b.name))
    },
    tasksInCalendarHash () {
      let calsWithSubjectIds = {}
      this.sortedTasks.forEach(subject => {
        const calId = subject.calendar_id
        if (!calsWithSubjectIds[calId]) {
          calsWithSubjectIds[calId] = [subject.id]
        } else {
          calsWithSubjectIds[calId].push(subject.id)
        }
      })
      return calsWithSubjectIds
    }
  },
  methods: {
    subjectHasTeachers (subject) {
      const cals = subject.cals ? subject.cals : []
      return cals.some(cal => cal.calendar_type === 'user')
    },
    subjectHasRoom (subject) {
      const cals = subject.cals ? subject.cals : []
      return cals.some(cal => cal.calendar_type === 'room')
    },
    getTeacherNames (subject) {
      const cals = subject.cals ? subject.cals : []
      const teachers = cals.filter(cal => cal.calendar_type === 'user')
      return teachers.map(cal => cal.name).join(', ')
    },
    setIsCreate (calendar) {
      this.$emit('setIsCreate', calendar)
    },
    setEditSubject (editSubject) {
      this.$emit('setEditSubject', editSubject)
    }
  }
}
</script>

<style scoped>

ul.doTable__items {
  margin: 0;
}

.doTable__klass {
  margin: 0;
}

.doTable__klass__header {
  display: flex;
  justify-content: space-between;
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  padding: 8px;
  font-weight: bold;
}

.doTable__klass__header label {
  color: #c0c0c0;
}

.subjects {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  margin: 0;
  border: 1px solid #e2e8f0;
  border-width: 0 1px 0 1px;
  background-color: #ffffff;
}

.subjects_subject {
  position: relative;
  top: 4px;
  left: 2px;
  right: 2px;
  bottom: 0;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 0px 10px 10px 0;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
  cursor: pointer;
}

.subjects_subject.subject--has-room, .subjects_subject.subject--has-user {
  padding-right: 20px;
}

.subjects_subject.subject--has-room.subject--has-user {
  padding-right: 26px;
}

.subjects_subject.subject--has-room:after {
  content: "\ea38";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-user:after {
  content: "\eaf7";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-room.subject--has-user:after {
  content: '';
  width: 18px;
  top: 10px;
  height: 18px;
  background-image: url('https://app.docendo.dk/static/img/app/bulk_create_subjects_userlocation.png');
  background-size: 100%;
  background-repeat: no-repeat;
}

.d-show-only-checkbox {
  display: flex;
  align-content: center;
  justify-content: flex-end;
  gap:0.5rem;
  margin: 1rem 0 0.75rem 0;
  cursor: pointer;
}

.d-show-only-checkbox > * {
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// ArbeidsplanSubjects.vue?3a19b9ce